import React from 'react';

import { StickyHeaderLinksGradBlockData } from 'api/cms';
import { CallToActionButton } from 'components/Button';

import StickyHeaderLinks from './StickyHeaderLinks';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const StickyHeaderLinksGradBlock = ({
  data: { links },
  loggedIn,
  hasGradProgram,
}: {
  data: StickyHeaderLinksGradBlockData;
  loggedIn: boolean;
  hasGradProgram: boolean;
}) => (
  <StickyHeaderLinks
    links={links}
    button={
      <CallToActionButton loggedIn={loggedIn} hasGradProgram={hasGradProgram} />
    }
  />
);

// eslint-disable-next-line import/no-default-export
export default StickyHeaderLinksGradBlock;
